// @ts-nocheck
import _ from 'lodash';
import qs from 'qs';
import { replace } from '@scale/frontend-lib/link';
import { ensureRelativeUrlOrAllowedDomain } from '@scale/frontend-lib/urls';

/**
 * The exact behavior of the redirect depends on whether we are in
 * node or in the browser:
 *
 * - node: the location header is written and the response is
 *   completed. Return value is undefined.
 *
 * - browser: next's router is used to perform the redirect, and a
 *   promise that never fulfills is returned—this is in order to halt
 *   the callers execution which is usually a getInitialProps static
 *   method of a next page.
 *
 * TODO: ensure the endless promise doesn't cause any memory leaks.
 */
const isomorphicRedirect = async (context, url, options = {}) => {
  const isServerRendered = context && context.req;
  let query = options.query || {};
  const previousURL = isServerRendered
    ? context.req.url
    : document.location.pathname + document.location.search;
  if (options.includeCurrentURL) {
    query.redirect_url = previousURL;
  }

  if (options.clear) {
    query.clear = '1';
  }

  const newQueryStart = url.indexOf('?');

  // handle the case where there are query params embedded within the url
  if (newQueryStart > -1 && newQueryStart < url.length - 1) {
    query = { ...query, ...qs.parse(url.substring(newQueryStart + 1)) };
  }

  if (options.forwardQueryParams) {
    const prevQueryStart = previousURL.indexOf('?');
    if (prevQueryStart > -1 && prevQueryStart < previousURL.length - 1) {
      const previousURLQuery = previousURL.substring(prevQueryStart + 1);
      const prevQueryParams = qs.parse(previousURLQuery);
      query = { ...prevQueryParams, ...query };
    }
  }

  if (Object.keys(query).length > 0) {
    url = (newQueryStart > -1 ? url.substring(0, newQueryStart) : url) + `?${qs.stringify(query)}`;
  }

  if (isServerRendered) {
    // If we're given an absolute URL, redirect to home page
    if (!options.absolute) {
      url = ensureRelativeUrlOrAllowedDomain(url);
    }

    context.res.writeHead(options.statusCode || 302, { Location: url });
    context.res.end();
  } else if (!context || !context.isDataPrefetch) {
    await clientRedirect(url, options.absolute);
  } else if (context && context.isDataPrefetch) {
    const err = new Error('would redirect in data prefetch link');
    err.isRedirect = true;
    throw err;
  }
};

export default isomorphicRedirect;

export function getDynamicUrl(url) {
  return url;
}

export function clientRedirect(originalUrl, absolute = false, forceReloadPage = false) {
  if (absolute) {
    window.location.href = originalUrl;
  } else {
    const as = originalUrl;
    const url = getDynamicUrl(originalUrl);
    replace(url, as, undefined, forceReloadPage);
  }
  return new Promise(_.noop); // Return a promise that will never fulfill to 'abort' the component loading sequence
}
